// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { availableCreditsTableStyles } from "@eisinc/App/Components/PaymentCenter/AvailableCreditsTable";
import Info from "@eisinc/XDL/Icons/Info";
import { color } from "@eisinc/XDL/Utilities";
import { showAllTabPagination } from "@eisinc/XDL/Utilities/sharedStyles";
import { IconWrapper } from "@insite/mobius/Icon";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import { css } from "styled-components";

availableCreditsTableStyles.wrapper = {
    css: css`
        width: 100%;
    `,
};

availableCreditsTableStyles.tableWrapper = {
    css: css`
        max-width: 100%;
        overflow: auto;
    `,
};

availableCreditsTableStyles.tableHeaderWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    `,
};

availableCreditsTableStyles.headerLeftWrapper = {
    css: css`
        margin-bottom: 10px;
        margin-top: 3px;
    `,
};

availableCreditsTableStyles.invoicesCount = {
    size: "20px",
    lineHeight: "24px",
    css: css`
        margin-right: 8px;
    `,
};

availableCreditsTableStyles.invoicesLabel = {
    size: "20px",
    lineHeight: "24px",
    css: css`
        margin-right: 3px;
    `,
};

availableCreditsTableStyles.invoicesTotal = {
    size: "20px",
    lineHeight: "24px",
    weight: 600,
};

availableCreditsTableStyles.invoiceItemNumberDataCellLink = {
    css: css`
        font-size: 14px;
        line-height: 17px;
    `,
};

availableCreditsTableStyles.backLink = {
    icon: {
        iconProps: {
            size: 18,
            src: ChevronLeft,
        },
    },
    css: css`
        margin-left: -5px;
        margin-bottom: 18px;

        ${IconWrapper} {
            margin-right: 4px;
        }
    `,
};

availableCreditsTableStyles.pagination = {
    ...showAllTabPagination,
};

availableCreditsTableStyles.tooltipWrapper = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

availableCreditsTableStyles.tooltip = {
    iconProps: {
        src: Info,
        size: 16,
        color: "primary.main",
        css: css`
            position: relative;
            top: 3px;
            margin-left: 4px;
        `,
    },
    typographyProps: {
        css: css`
            white-space: pre-wrap;
        `,
    },
};

availableCreditsTableStyles.selectedRow = {
    css: css`
        &&&& {
            &.paid {
                background-color: ${color("success.main", 0.05)};

                .pending {
                    font-weight: 500;
                    color: ${color("success.main")};
                }
            }
        }
    `,
};
